<template>
  <div>
    <!-- User Info: Input Fields -->
    <validation-observer ref="simpleRules">
      <b-form @submit.prevent="onSubmitForm">
        <div class="d-flex mb-2">
          <feather-icon
            icon="UserIcon"
            size="19"
          />
          <h4 class="mb-0 ml-50">
            Dados Pessoais
          </h4>
        </div>

        <b-row>
          <b-col
            cols="12"
            md="4"
          >
            <b-form-group
              label="Tipo Pessoa"
              label-for="user_tipo_pessoa"
            >
              <v-select
                v-model="clienteData.tipo_pessoa_cliente"
                :disabled="disablesInput"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="[
                  { label: 'Fisica', value: 'F' },
                  { label: 'Juridica', value: 'J' },
                ]"
                :reduce="val => val.value"
                :clearable="true"
                input-id="user_tipo_pessoa"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>

          <!-- Field: Username -->
          <b-col
            cols="12"
            md="6"
          >
            <b-form-group
              label="Nome"
              label-for="nome_cliente"
            >
              <validation-provider
                #default="{ errors }"
                name="nome_cliente"
                rules="required"
              >
                <b-form-input
                  id="nome_cliente"
                  v-model="clienteData.nome_cliente"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Ex.: João da Silva"
                />
                <small class="text-danger">{{ errors[0] ? 'Nome é obrigatório' : '' }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Field: Full Name -->
          <b-col
            cols="12"
            md="6"
          >
            <b-form-group
              :label="clienteData.tipo_pessoa_cliente === 'F' ? 'CPF' : 'CNPJ'"
              label-for="documento_cliente"
            >
              <validation-provider
                #default="{ errors }"
                name="documento_cliente"
                rules="required"
              >
                <cleave
                  v-if="clienteData.tipo_pessoa_cliente === 'F'"
                  id="documento_cliente"
                  v-model="clienteData.documento_cliente"
                  :disabled="disablesInput"
                  class="form-control"
                  :raw="false"
                  :options="optionsMask.cpf"
                  placeholder="Ex.: 123.456.789-00"
                  :class="{'border-danger': errors.length > 0}"
                />

                <cleave
                  v-else
                  id="documento_cliente"
                  v-model="clienteData.documento_cliente"
                  :disabled="disablesInput"
                  class="form-control"
                  :raw="false"
                  :options="optionsMask.cnpj"
                  placeholder="Ex.: 12.345.678/0001-00"
                  :class="{'border-danger': errors.length > 0}"
                />
                <small class="text-danger">{{ errors[0] ? 'Documento é obrigatório' : '' }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Field: Status -->
          <b-col
            cols="12"
            md="6"
          >
            <b-form-group
              label="Status"
              label-for="ativo_cliente"
            >
              <v-select
                v-model="clienteData.ativo_cliente"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="statusOptions"
                :reduce="val => val.value"
                :clearable="false"
                input-id="ativo_cliente"
              />
            </b-form-group>
          </b-col>

          <!-- Field: Role -->
          <b-col
            cols="12"
            md="6"
          >
            <b-form-group
              label="Grupos Permissão"
              label-for="id_grupousuario"
            >
              <validation-provider
                #default="{ errors }"
                name="id_grupousuario"
                rules="required"
              >
                <v-select
                  v-model="clienteData.id_grupousuario"
                  :class="{ 'border-danger border-rounded-1': errors.length > 0 }"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="roleOptions"
                  :state="errors.length > 0 ? false:null"
                  :reduce="val => val.value"
                  :clearable="false"
                  input-id="id_grupousuario"
                />
                <small class="text-danger">{{ errors[0] ? 'Grupos Permissão é obrigatória' : '' }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col
            cols="12"
            md="6"
          >
            <b-form-group
              label="Login"
              label-for="login_usuario"
            >
              <validation-provider
                #default="{ errors }"
                name="login_usuario"
                rules="required|email"
              >
                <b-form-input
                  id="login_usuario"
                  v-model="clienteData.login_usuario"
                  :disabled="disablesInput"
                  type="email"
                  :state="errors.length > 0 ? false:null"
                  autocomplete="email"
                  placeholder="Ex.: email@email.com"
                />
                <small class="text-danger">{{ errors[0] ? 'Digite um E-mail valido' : '' }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col
            cols="12"
            md="6"
          >

            <b-form-group
              label="Senha"
              label-for="senha_usuario"
            >
              <validation-provider
                #default="{ errors }"
                name="senha_usuario"
                rules="required"
              >
                <b-form-input
                  id="senha_usuario"
                  v-model="clienteData.senha_usuario"
                  :disabled="disablesInput"
                  :state="errors.length > 0 ? false:null"
                  placeholder="********"
                />
                <small class="text-danger">{{ errors[0] ? 'Senha é obrigatória' : '' }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

        </b-row>

        <FormEndereco
          v-model="clienteData"
          :uf-options="ufOptions"
          :cidade-options="cidadeOptions"
          @onUfsChange="handleUfsChange($event)"
          @onCidadeChange="handleCidadesChange($event)"
        />
        <!-- Action Buttons -->
        <b-button
          variant="primary"
          type="submit"
          class="my-1 mb-sm-0 mr-0 mr-sm-1"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
        >
          {{ disablesInput ? 'Atualizar' : 'Cadastar' }}
        </b-button>
        <b-button
          variant="outline-secondary"
          class="my-1 mb-sm-0 mr-0 mr-sm-1"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          @click="$router.push({ name: 'app-admin-cliente' })"
        >
          Cancelar
        </b-button>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import {
  BButton, BCol, BForm, BFormGroup, BFormInput, BRow,
} from 'bootstrap-vue'
import Cleave from 'vue-cleave-component'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { email, required } from '@validations'
import { avatarText } from '@core/utils/filter'
import vSelect from 'vue-select'
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
import { computed, onMounted, ref } from '@vue/composition-api'
import useClienteList from '@/views/apps/clientes/clientes-list/useClienteList'
import FormEndereco from '@/components/app-cliente/FormEndereco.vue'
import store from '@/store'
import useOptionsMask from '@/composables/useOptionsMask'

export default {
  components: {
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    ValidationProvider,
    ValidationObserver,
    FormEndereco,
    vSelect,
    Cleave,
  },
  model: {
    prop: 'clienteData',
    event: 'handleSubmit',
  },
  props: {
    clienteData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      required,
      email,
    }
  },
  setup(props, { emit }) {
    const { resolveUserRoleVariant } = useClienteList()
    const { optionsMask } = useOptionsMask()
    const ufOptions = ref([])
    const simpleRules = ref(null)
    const cidadeOptions = ref([])
    const roleOptions = ref([])

    const handleUfsChange = uf => {
      store.dispatch('appUfs/GET_UFS_BY_UF', uf)
      ufOptions.value = store.getters['appUfs/getUfs']
    }

    const handleCidadesChange = cidadeNome => {
      store.dispatch('appAdmCidade/GET_CIDADES_BY_CIDADE_NOME', cidadeNome)
      cidadeOptions.value = store.getters['appAdmCidade/getCidades']
    }

    const validationForm = () => {
      simpleRules.value.validate().then(success => {
        if (success) {
          emit('handleSubmit')
        }
      })
    }

    const disablesInput = computed(() => props.clienteData.id_cliente !== undefined && props.clienteData.id_cliente !== null)

    const onSubmitForm = () => {
      validationForm()
    }

    const statusOptions = [
      { label: 'Ativo', value: 1 },
      { label: 'Inativo', value: 0 },
    ]

    // ? Demo Purpose => Update image on click of update
    const refInputEl = ref(null)
    const previewEl = ref(null)

    const { inputImageRenderer } = useInputImageRenderer(refInputEl, base64 => {
      // eslint-disable-next-line no-param-reassign
      props.clienteData.avatar = base64
    })

    onMounted(() => {
      store.dispatch('app-adm-usuario/fetchGrups')
        .then(data => {
          data.grupos.forEach(grup => {
            if (store.getters['auth/getUserData'].role !== 'Admin' && grup.id === 1) {
              return
            }
            roleOptions.value.push({
              label: grup.grupousuario,
              value: grup.id,
            })
          })
        })
      store.dispatch('appUfs/GET_UFS')
        .then(() => {
          ufOptions.value = store.getters['appUfs/getUfs']
        })
      store.dispatch('appAdmCidade/GET_CIDADES')
        .then(() => {
          cidadeOptions.value = store.getters['appAdmCidade/getCidades']
        })
    })

    return {
      resolveUserRoleVariant,
      avatarText,
      roleOptions,
      statusOptions,

      //  ? Demo - Update Image on click of update button
      refInputEl,
      previewEl,
      inputImageRenderer,
      ufOptions,
      cidadeOptions,
      handleUfsChange,
      handleCidadesChange,
      simpleRules,
      validationForm,
      onSubmitForm,
      disablesInput,
      optionsMask,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
